import React from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';

const { Header } = Layout;

const HeaderComponent = ({logo, website}) => {
    const {pathname} = useLocation();
    const pathId = pathname.replace("/reservation/", "");
    const [fleetName,, facilityId] = pathId.split("_");

    let customLogoStyle = null;

    if (fleetName === 'Partnership-for-Children' && facilityId === "3c4i8k8lmbp3f75g") {
        customLogoStyle = {
            marginLeft: 'auto',
            marginRight: 'auto',
            height: '80px'
        };
    }

    return (
        <Header className='header'>
            { logo &&
                <img
                    className="header-logo"
                    style={customLogoStyle}
                    src={logo}
                    alt="logo"
                    onClick={() => {
                        let url = website;

                        if (!/^https?:\/\//i.test(url)) {
                            url = 'https://' + url;
                        }

                        window.location.href = url;
                    }}
                />
            }
        </Header>
    )
};
  
export default HeaderComponent;